import { Alert } from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

interface AlertComponentProps {
  severity: 'info' | 'success' | 'warning' | 'error'
  title: string
  content: string
  onNavigate?: () => void
  navigateText?: string
}

interface AlertColorProps {
  icon: string
  content: string
  bg: string
}

const useStyles = makeStyles({
  alertIconInfo: {
    '& .MuiSvgIcon-root': {
      color: '#0288D1 !important',
    },
    backgroundColor: '#E5F6FD !important',
  },

  alertContentColorInfo: {
    color: '#014361 !important',
  },

  alertIconWarning: {
    '& .MuiSvgIcon-root': {
      color: '#EF6C00 !important',
    },
    backgroundColor: '#FFF3E0 !important',
  },

  alertContentColorWarning: {
    color: '#663C00 !important',
  },

  alert: {
    margin: '0.75rem 0',
  },

  alertContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '0.35rem',
    fontSize: '13px ',
  },

  link: {
    color: '#3024E1 !important',
    fontWeight: '600 !important',
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  alertTitle: {
    fontWeight: '600 !important',
    fontSize: '14px !important',
  },
})

const AlertComponent = ({ content, severity, title, onNavigate, navigateText }: AlertComponentProps) => {
  const classes = useStyles()

  let icon = classes.alertIconInfo
  let contentColor = classes.alertContentColorInfo

  if (severity === 'warning') {
    icon = classes.alertIconWarning
    contentColor = classes.alertContentColorWarning
  }

  return (
    <Alert
      severity={severity}
      className={clsx(classes.alert, icon)}
    >
      <div className={clsx(classes.alertContent, contentColor)}>
        <span className={classes.alertTitle}>{title}</span>
        <span>
          {content + ' '}
          <span
            className={classes.link}
            onClick={onNavigate}
          >
            {navigateText}
          </span>
        </span>
      </div>
    </Alert>
  )
}

export default AlertComponent
